// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__xnfDw","approved":"Status_approved__19DCF","rejected":"Status_rejected__3iTfG","expired":"Status_expired__1i5FP","label":"Status_label__3qytQ"};